module.exports = __webpack_public_path__ + "static/media/specials-grayscale.1f17c56e.jpg";